import React from 'react';

import CodeInput from './CodeInput';
import CodeExpiresIn from './CodeExpiresIn';

const CodeInputWithExpiry = ({
  onChange,
  onSubmit,
  isError,
}) => {
  return <div className="code_input__container_with_expiry">
    <CodeInput
      onChange={onChange}
      onSubmit={onSubmit}
      isError={isError}
    />
    <CodeExpiresIn />
  </div>;
};

export default CodeInputWithExpiry;
